<div class="row">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span class="ml-2">{{head}}</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor: pointer">
                    <i
                        class="fa-solid fa-xmark"
                        (click)="Close()"
                        style="font-size: xx-large"
                    ></i>
                </a>
            </div>
        </div>
        <div class="card card_content" >
            <div >
            <button type="button" class="btn btn-secondary mr-2" (click)="downloadtemplate()">
                <i class="fa fa-download"></i> Download Template
              </button>
            </div>
            <form [formGroup]="form">
            <div class="row mt-4 d-flex justify-content-center">
                <div class="col-8">
                    <div class="padd-right-file" style="display: flex;">
                        <mat-form-field appearance="fill" hideRequiredMarker (click)="selectFile()">
                            <mat-label>Attachment</mat-label>
                            <input matInput  id="AttachmentFileName" placeholder="Select Attachment"
                                formControlName="AttachmentFileName" autocomplete="off" specialIsAlphaNumeric
                                class="col-10" autocomplete="off" readonly>
                        </mat-form-field>
                        <button type="button" (click)="selectFile()" *ngIf="!isFileSelected"
                            class="badge bg-light-blue image-button">
                           <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg" style="width: 26px;"/>
                        </button>
                        <button type="button" (click)="reset()" *ngIf="isFileSelected"
                            class="badge bg-light-blue image-button">
                            <img style="filter: invert(1);width: 26px;"
                                src="../../../../assets/Home-Connect/icons/delete.svg" />
                        </button>
                    </div>

                </div>
            </div>
            <div class="mt-4 mr-4" style="text-align: end;" >
                <button type="button" matRipple class="btn btn-primary" (click)="save()">
                    Save
                </button>
            </div>
        </form>
            </div>
        </div>
        </div>
            